import React from 'react';
import { useTranslation } from 'react-i18next';
import { TertiaryButton } from '@dev/ee-components';
import { useDispatch } from 'react-redux';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { FinishOnboarding } from '@/store/onboarding/actions';
import { useGA4SkipEvent } from '@/services/hooks/ga4/useGA4SkipEvent';

export const OnboardingSkip = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleGA4SKipEvent = useGA4SkipEvent();

    const showConfimation = (): void => {
        const dialogParams: ShowDialogParams = {
            title: t('onboardingskip', { count: 1 }),
            destructiveLabel: t('onboardingskip'),
            onClickDestructive: (): void => {
                dispatch(FinishOnboarding());
                handleGA4SKipEvent();
            },
            cancelLabel: t('cancel'),
            body: t('onboardingskip_message'),
        };

        dispatch(ShowDialog(dialogParams));
    };

    return <TertiaryButton text={t('onboardingskip')} onClick={showConfimation} style={{ alignSelf: 'start' }} />;
};
